import React, { useState, useEffect } from "react";
import { Box, Typography, makeStyles, Tooltip, withStyles } from "@material-ui/core";
import InfoIcon from "../../assets/img/info.png";
import ArcIcon from "../../assets/img/arc.svg";
import RatingIcon from "../../assets/img/rating.svg";
import TwentyFourSevenIcon from "../../assets/img/twenty-four-seven.svg";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "#282F36",
    border: "1px solid #dadde9",
    textAlign: "center",
  },
}))(Tooltip);

const Accreditation = () => {
  const useStyles = ({ breakpoints: { down } }) => ({
    container: {
      display: "flex",
      boxSizing: "border-box",
      justifyContent: "space-around",
      marginTop: "36px",
      margin: "0 auto",
      padding: "17px 24px",
      borderRadius: "16px",
      backgroundColor: "#ffffff80",
      alignItems: "center",
      maxWidth: "580px",
      gap: "16px",
      flexWrap: "wrap",
      [down("xs")]: {
        justifyContent: "space-between",
        padding: "16px",
        marginTop: "12px",
        margin: "0 auto",
      },
    },
    card: {
      gap: "8px",
      textAlign: "center",
      [down("xs")]: {
        textAlign: "left",
        maxWidth: "26%",
      },
    },
    secondaryText: {
      alignItems: "center",
      gap: "4px",
      color: "#838D95",
      fontSize: "10px",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
  });
  const classes = makeStyles(useStyles)();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      setOpen(false);
    };

    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <Box>
      <Box className={classes.container}>
        <LightTooltip
          title={
            <Typography>
              ARC-accredited agency that meets strict industry standards.
            </Typography>
          }
          className={classes.card}
          style={{ cursor: "pointer" }}
          placement="top"
          arrow
          open={open}
          disableHoverListener
          disableFocusListener
          disableTouchListener
        >
          <Box
            onClick={() => {
              if (isMobile) setOpen((prev) => !prev);
            }}
            onMouseEnter={() => {
              if (!isMobile) setOpen(true);
            }}
            onMouseLeave={() => {
              if (!isMobile) setOpen(false);
            }}
          >
            <img src={ArcIcon} alt="arc" />
            <Typography className={classes.secondaryText}>
              Accredited Agency <img src={InfoIcon} style={{ marginBottom: "-3px" }} alt="info" />
            </Typography>
          </Box>
        </LightTooltip>

        <Box className={classes.card}>
          <img src={TwentyFourSevenIcon} alt="24/7" />
          <Typography className={classes.secondaryText}>Live concierge</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Accreditation;
